var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen"},[_c('PortalNav'),(_vm.system && _vm.route !== 'Dashboard')?_c('router-view'):_c('Dashboard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }